<div class="header-row">
  <div class="header-col">
    <label for="clientName" class="control-label">{{ 'i18n.shared.fields.client' | translate }}</label>
    <input id="clientName" type="text" class="form-control" disabled="true" [value]="protocol?.client?.name" />
  </div>
  <div class="header-col">
    <label for="configuration" class="control-label">{{ 'i18n.domain.import-protocol.configuration' | translate }}</label>
    <input id="configuration" type="text" class="form-control" disabled="true" [value]="protocol?.configurationName"/>
  </div>
  <div class="header-col">
    <label for="createdOn" class="control-label">{{ 'i18n.domain.import-protocol.header.created-on' | translate }}</label>
    <input id="createdOn" type="text" class="form-control" disabled="true" [value]="protocol?.createdOn.toJSDate() | date:'dd.MM.yyyy HH:mm:ss'"/>
  </div>
  <div class="header-col">
    <label for="succeededOn" class="control-label">{{ 'i18n.domain.import-protocol.header.succeeded-on' | translate }}</label>
    <input id="succeededOn" type="text" class="form-control" disabled="true" [value]="succeededOn | date:'dd.MM.yyyy HH:mm:ss'"/>
  </div>
  <div class="header-col">
    <label for="successState" class="control-label">{{ 'i18n.domain.import-protocol.state' | translate }}</label>
    <input id="successState" type="text" class="form-control" [ngClass]="{'error-state': hasError}" disabled="true" [value]="successState | translate"/>
  </div>
</div>
<div class="header-row">
  <div class="header-col">
    <label for="sourceInfo" class="control-label">{{ 'i18n.domain.import-protocol.imported-by' | translate }}</label>
    <input id="sourceInfo" type="text" class="form-control" disabled="true" [value]="protocol?.sourceInfo" />
  </div>
  <div class="header-col">
    <label for="type" class="control-label">{{ 'i18n.shared.fields.type' | translate }}</label>
    <input id="type" type="text" class="form-control" disabled="true" [value]="type | translate"/>
  </div>
  <div class="header-col">
    <label for="originalFile" class="control-label">{{ 'i18n.domain.import-protocol.header.original-file' | translate }}</label>
    <input id="originalFile" type="text" class="form-control" disabled="true" [value]="protocol?.originalFileName"/>
  </div>
  <div class="header-col">
    <label for="importFile" class="control-label">{{ 'i18n.domain.import-protocol.header.import-file' | translate }}</label>
    <input id="importFile" type="text" class="form-control" disabled="true" [value]="protocol?.importFileName"/>
  </div>
  <div class="header-col">
    <label for="fixedImportFile" class="control-label">{{ 'i18n.domain.import-protocol.header.fixed-import-file' | translate }}</label>
    <input id="fixedImportFile" type="text" class="form-control" disabled="true" [value]="protocol?.correctedFileName"/>
  </div>
</div>
